import { Button, CircularProgress } from "@mui/material";
import { Upload } from "@mui/icons-material";
import { useT } from "../../i18n";
import {
  useAssignBaustelleZuRechnung,
  useSaveAndResendDatev,
  useUpdateZugewieseneBaustelle,
} from "../../client/hooks";
import { RechnungDaten } from "../../api";
import { useNavigate } from "react-router";
import { useMutation, useQueryClient } from "react-query";
import { formatAsFloat } from "../../formatterHelpers";
import { ZugewieseneBaustelleUpdated } from "../eingangsrechnungen/BaustellenEintrag";
import { useState } from "react";
import { formValuesToRechnungData } from "../../pages/rechnungen/RechnungsFormular";

export const ResendDatevButton = ({
  disabled,
  rechnungId,
  rechnung,
}: {
  disabled: boolean;
  rechnungId: string;
  rechnung: any; // Weil Rechnungstyp doof :(
}) => {
  const { t } = useT("eingangsrechnung");
  const { mutateAsync: updateRechnung } = useResendDatev(rechnungId);
  const createBaustellenEintrag = useAssignBaustelleZuRechnung();
  const updateBaustellenEintrag = useUpdateZugewieseneBaustelle();
  const nav = useNavigate();
  const [sending, setSending] = useState(false);

  return (
    <Button
      sx={{ marginTop: 3, ml: 2 }}
      variant="contained"
      color="success"
      disabled={disabled}
      startIcon={
        sending ? (
          <CircularProgress size={"10pt"} color={"inherit"} />
        ) : (
          <Upload />
        )
      }
      onClick={() => {
        try {
          setSending(true);
          rechnung.baustellenEintrag.forEach(
            (zugewieseneBaustelle: ZugewieseneBaustelleUpdated) => {
              const baustelleData = {
                baustellenId: zugewieseneBaustelle.baustelle?.id,
                prueferId: zugewieseneBaustelle.pruefer?.id,
                betrag: formatAsFloat(zugewieseneBaustelle.betrag),
                pruefStatus: zugewieseneBaustelle.pruefStatus,
                leistung: zugewieseneBaustelle.leistung,
              };

              if (zugewieseneBaustelle.id) {
                updateBaustellenEintrag(
                  rechnungId,
                  zugewieseneBaustelle.id,
                  { rechnungBeglichenAm: rechnung.bezahltAm },
                  baustelleData
                );
              } else {
                createBaustellenEintrag(
                  rechnungId,
                  { rechnungBeglichenAm: rechnung.bezahltAm },
                  baustelleData
                );
              }
            }
          );

          updateRechnung(formValuesToRechnungData(rechnung)).then(() =>
            nav("/eingangsrechnungen")
          );
        } catch (error) {
          console.error("Failed to resend to Datev:", error);
        } finally {
          setSending(false);
        }
      }}
    >
      {t("resend-datev")}
    </Button>
  );
};

function useResendDatev(rechnungId: string) {
  const saveAndResendDatev = useSaveAndResendDatev();
  const queryClient = useQueryClient();
  return useMutation(
    (input: RechnungDaten) => {
      return saveAndResendDatev(rechnungId, input);
    },
    {
      onSuccess: async () => {
        queryClient.invalidateQueries(["rechnungen"]);
      },
    }
  );
}
